export function slugify(text) {
    if (!text) return '';

    return text
        .toString()
        .toLowerCase()
        .trim()
        .normalize('NFD')                  // Normalize accented characters
        .replace(/[\u0300-\u036f]/g, '')   // Remove diacritics
        .replace(/\s+/g, '-')              // Replace spaces with -
        .replace(/[^\w\-]+/g, '')          // Remove all non-word chars
        .replace(/\-\-+/g, '-')            // Replace multiple - with single -
        .replace(/^-+/, '')                // Trim - from start
        .replace(/-+$/, '');               // Trim - from end
}
